<template>
    <div>
        <div
            class="flex flex-wrap -mx-4"
            v-if="
                can('access-instruments-stats') &&
                category.id &&
                category.rentable
            "
        >
            <div class="w-full lg:w-1/3 px-4 mb-4">
                <div
                    class="h-full bg-white rounded-lg shadow-md hover:shadow-lg transition-slow cursor-pointer"
                >
                    <div
                        class="flex items-center justify-between px-4 py-2 border-b"
                    >
                        <h3 class="text-lg font-heading">Всего</h3>
                    </div>

                    <div class="flex flex-col px-4 py-2">
                        <h3 class="text-3xl font-heading font-semibold">
                            {{ rentableStats.total }}
                        </h3>
                    </div>
                </div>
            </div>

            <div class="w-full lg:w-1/3 px-4 mb-4">
                <div
                    class="h-full bg-white rounded-lg shadow-md hover:shadow-lg transition-slow cursor-pointer"
                >
                    <div
                        class="flex items-center justify-between px-4 py-2 border-b"
                    >
                        <h3 class="text-lg font-heading">В наличии</h3>
                    </div>

                    <div class="flex flex-col px-4 py-2">
                        <div
                            v-for="city in rentableStats.stock"
                            :key="city.id"
                            class="text-sm font-heading font-semibold"
                        >
                            {{ city.name }} – {{ city.products_count }}шт.
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full lg:w-1/3 px-4 mb-4">
                <div
                    class="h-full bg-white rounded-lg shadow-md hover:shadow-lg transition-slow cursor-pointer"
                >
                    <div
                        class="flex items-center justify-between px-4 py-2 border-b"
                    >
                        <h3 class="text-lg font-heading">В аренде</h3>
                    </div>

                    <div class="flex flex-col px-4 py-2">
                        <h3 class="text-3xl font-heading font-semibold">
                            {{ rentableStats.rent }}
                        </h3>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="flex flex-wrap -mx-4"
            v-if="category.id && productsStats.length && false"
        >
            <div
                class="w-full lg:w-1/3 px-4 mb-4"
                v-for="product in productsStats"
                :key="product.id"
            >
                <div
                    class="h-full bg-white rounded-lg shadow-md hover:shadow-lg transition-slow cursor-pointer"
                >
                    <div
                        class="flex items-center justify-between px-4 py-2 border-b"
                    >
                        <h3 class="text-lg font-heading">{{ product.name }}</h3>
                    </div>

                    <div class="flex flex-col px-4 py-2">
                        <h3 class="text-3xl font-heading font-semibold">
                            {{ product.revenue }} ₽
                        </h3>
                        <span class="text-xs">Выручка</span>

                        <hr class="mb-1 mt-2" />

                        <h3 class="text-xl font-heading font-semibold">
                            {{ product.orders_count }}
                        </h3>
                        <span class="text-xs">Продажи</span>
                    </div>
                </div>
            </div>
        </div>
      <div class="w-full" style="padding-left: 250px">
        <resource-index
            v-if="ready"
            :title="title"
            endpoint="admin/products"
            :params="params"
        >
          <template slot="header-buttons">
            <a href="/api/products/export"
                class="btn btn-secondary mr-2"
            >
              Экспортировать
            </a>
            <router-link
                class="btn btn-secondary"
                :to="{
                        name: 'admin.products.create',
                    }"
            >
              Создать
            </router-link>
          </template>

          <template #table-header="{ setOrder }">
            <tr class="border-b">
              <th class="text-left p-3 px-5" scope="col">Название</th>
              <th class="text-left p-3 px-5" scope="col">Город</th>
              <th
                  v-if="!category.id"
                  class="text-left p-3 px-5"
                  scope="col"
              >
                Категория
              </th>
              <th
                  @click="setOrder('price')"
                  class="text-left p-3 px-5"
                  scope="col"
              >
                Стоимость
              </th>
              <th class="text-left p-3 px-5" scope="col">Кол-во</th>
              <th class="text-left p-3 px-5" scope="col">Статус</th>
              <template v-if="$route.query.category == 1">
                <th class="text-left p-3 px-5" scope="col">Тональность</th>
                <th class="text-left p-3 px-5" scope="col">Строй</th>
                <th class="text-left p-3 px-5" scope="col">Сталь</th>
                <th class="text-left p-3 px-5" scope="col">Многонотник</th>
              </template>
              <th class="text-left p-3 px-5" scope="col">Комментарий</th>
              <th class="text-left p-3 px-5" scope="col"></th>
            </tr>
          </template>

          <template v-slot:table-filters="slotProps">
            <tr class="border-b bg-gray-100">
              <th class="p-3 px-5" scope="col">
                <text-field
                    placeholder="Название или ID"
                    :wrap="false"
                    v-model="slotProps.filters.name"
                />
              </th>

              <th class="p-3 px-5" scope="col">
                <select-field
                    label="name"
                    valueName="id"
                    :wrap="false"
                    :options="selects.branches"
                    v-model="slotProps.filters.branch_id"
                />
              </th>

              <th class="p-3 px-5" scope="col">
                <text-field
                    placeholder=""
                    :wrap="false"
                    v-model="slotProps.filters.price"
                />
              </th>

              <th v-if="!category.id" class="p-3 px-5" scope="col">
                <select-field
                    label="name"
                    valueName="id"
                    :wrap="false"
                    :options="selects.categories"
                    v-model="slotProps.filters.category_id"
                />
              </th>

              <th class="p-3 px-5" scope="col"></th>
              <th class="p-3 px-5" scope="col">
                <select-field
                    label="label"
                    valueName="value"
                    :wrap="false"
                    :options="selects.statuses"
                    v-model="slotProps.filters.status"
                />
              </th>

              <template v-if="$route.query.category == 1">
                <th class="p-3 px-5 flex-shrink-0">
                  <select-field
                      label="name"
                      valueName="id"
                      :wrap="false"
                      :options="selects.tonalities"
                      v-model="slotProps.filters.tonality_id"
                  />
                </th>
                <th class="p-3 px-5 flex-shrink-0">
                  <select-field
                      label="name"
                      valueName="id"
                      :wrap="false"
                      :options="selects.tuning"
                      v-model="slotProps.filters.tune_id"
                  />
                </th>
                <th class="p-3 px-5 flex-shrink-0">
                  <select-field
                      label="name"
                      valueName="id"
                      :wrap="false"
                      :options="selects.steel"
                      v-model="slotProps.filters.steel_id"
                  />
                </th>
                <th class="p-3 px-5 flex-shrink-0">
                  <select-field
                      label="name"
                      valueName="id"
                      :wrap="false"
                      :options="selects.polynote"
                      v-model="slotProps.filters.polynote_id"
                  />
                </th>
              </template>

              <th class="p-3 px-5" scope="col">
              </th>
              <th class="p-3 px-5" scope="col"></th>
            </tr>
          </template>

          <template v-slot:row="slotProps">
            <td class="p-3 px-5">
                    <span v-if="category.rentable"
                    >{{ slotProps.entry.unique_id }} –</span
                    >
              {{ slotProps.entry.name }}
            </td>

            <td class="p-3 px-5">
              {{
                slotProps.entry.branch
                    ? slotProps.entry.branch.name
                    : "–"
              }}
            </td>

            <td v-if="!category.id" class="p-3 px-5">
                    <span class="badge whitespace-no-wrap badge-gray">{{
                        slotProps.entry.category.name
                      }}</span>
            </td>

            <td class="p-3 px-5">
                    <span class="badge whitespace-no-wrap badge-success"
                    >{{ slotProps.entry.price }} ₽</span
                    >
            </td>

            <td class="p-3 px-5">
                    <span class="badge whitespace-no-wrap badge-blue">{{
                        slotProps.entry.amount
                            ? slotProps.entry.amount + " шт."
                            : "–"
                      }}</span>
            </td>

            <td class="p-3 px-5">
                    <span
                        :class="`badge whitespace-no-wrap badge-${
                            selects.statuses.find(
                                (status) =>
                                    status.value == slotProps.entry.status
                            ).color
                        }`"
                    >{{
                        selects.statuses.find(
                            (status) =>
                                status.value == slotProps.entry.status
                        ).label
                      }}</span
                    >
            </td>

            <template v-if="$route.query.category == 1">
              <td class="p-3 px-5">
                {{ slotProps.entry.tonality ? slotProps.entry.tonality.name : '' }}
              </td>
              <td class="p-3 px-5">
                {{ slotProps.entry.tune ? slotProps.entry.tune.name : '' }}
              </td>
              <td class="p-3 px-5">
                {{ slotProps.entry.steel ? slotProps.entry.steel.name : '' }}
              </td>
              <td class="p-3 px-5">
                {{ slotProps.entry.polynote ? slotProps.entry.polynote.name : '' }}
              </td>
              <td class="p-3 px-5">
                {{ slotProps.entry.comment }}
              </td>
            </template>

            <td class="p-3 px-5">
              <router-link
                  :to="{
                            name: 'admin.products.edit',
                            params: {
                                id: slotProps.entry.id,
                            },
                        }"
                  class="btn btn-info"
              >Изменить</router-link
              >
            </td>
          </template>
        </resource-index>
      </div>
    </div>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex,
    },

    data() {
        return {
            ready: !this.$route.query.category,
            rentableStats: {},
            productsStats: [],
            title: "Товары",
            category: {
                id: this.$route.query.category,
            },
            params: {
                category_id: this.$route.query.category
                    ? this.$route.query.category
                    : null,
            },
            selects: {
                ready: false,
                categories: [],
                branches: [],
                statuses: [
                    {
                        value: "not_sold",
                        label: "Не продан",
                        color: "",
                    },
                    {
                        value: "stock",
                        label: "В наличии",
                        color: "info",
                    },
                    {
                        value: "book",
                        label: "Забронирован",
                        color: "yellow",
                    },
                    {
                        value: "rent",
                        label: "В аренде",
                        color: "indigo",
                    },
                    {
                        value: "sold",
                        label: "Продан",
                        color: "pink",
                    },
                  {
                    value: "sold",
                    label: "Продан",
                    color: "pink",
                  },
                  {
                    value: "on_way",
                    label: "На пути с маркетплейса",
                    color: "pink",
                  },
                  {
                    value: "fbo",
                    label: "ФБО",
                    color: "pink",
                  },
                ],
                steel: [],
                tonalities: [],
                tuning: [],
                polynote: [],
            },
        };
    },

    methods: {
        async fetch() {
            axios
                .get(`/admin/products/categories/${this.category.id}/stats`)
                .then((response) => {
                    this.productsStats = response.data.data;
                });

            await axios
                .get(`/admin/products/categories/${this.category.id}`, {
                    params: {
                        stats: true,
                    },
                })
                .then((response) => {
                    this.category = response.data.data;
                    this.rentableStats = response.data.stats;
                });

            this.title = this.category.name;
            this.ready = true;
        },

        async fetchSelects() {
          await axios
              .get("/admin/instruments")
              .then((response) => {
                const data = response.data;
                this.selects.tonalities = data.tonalities;
                this.selects.steel = data.steel;
                this.selects.tuning = data.tuning;
                this.selects.polynote = data.polynote
              });

            await axios
                .get("/admin/products/categories/all")
                .then((response) => {
                    this.selects.categories = response.data.data;
                });

            await axios.get("/admin/branches/all").then((response) => {
                this.selects.branches = response.data.data;
            });

            this.selects.ready = true;
        },
    },

    mounted() {
        this.fetchSelects();
        if (this.category.id) {
            this.fetch();
        }
    },
};
</script>
